export const formatPhoneNumber = (phoneNumber: string) => {
  return phoneNumber.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3')
}

/**
 * E.164 포맷 전화번호를 표시용 포맷으로 변환
 * @param e164Number - E.164 포맷 전화번호 (+821012345678)
 * @returns 표시용 포맷 (+82 10-1234-5678)
 */
export const formatE164ForDisplay = (e164Number: string): string => {
  if (e164Number.startsWith('+82')) {
    const localNumber = e164Number.slice(3)
    if (localNumber.length === 10) {
      return `+82 ${localNumber.slice(0, 2)}-${localNumber.slice(2, 6)}-${localNumber.slice(6)}`
    }
  }
  return e164Number
}
